export default __webpack_public_path__ + "static/media/education.0cbf0006.jpg";